import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../../../../web/components/Button';
import { StarRating } from '../../../../../../web/components/surveys/StarRating';
import { IFormField, ISatisfactionSurvey, ISatisfactionSurveyResponse } from '../../../../../models/Api';
import { useErrorMessagesContext } from '../../../../../components/ErrorModalProvider/context';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	onRequestSubmit?(response: ISatisfactionSurveyResponse): Promise<any>;
	styles?: StyleDeclarationValue[];
	survey: ISatisfactionSurvey;
}

export const SatisfactionSurvey: React.FC<IProps> = props => {
	const { className, styles = [], survey, onRequestSubmit } = props;
	const ratingStarStyles = React.useRef<StyleDeclarationValue[]>([styleSheet.ratingStar]).current;
	const { pushError } = useErrorMessagesContext();

	const [rating, setRating] = React.useState<number>(0);

	// Check if this is the only question (no custom form fields or all fields are hidden)
	const hasAdditionalQuestions =
		survey.customForm?.fields?.some((field: IFormField<string>) => !field.isHidden) || false;
	const introStyle = hasAdditionalQuestions ? styleSheet.intro : styleSheet.introLargeText;

	const onSubmitFeedbackClicked = () => {
		if (rating === 0) {
			pushError(['Please provide a rating to continue.']);
			return;
		}
		const response: ISatisfactionSurveyResponse = {
			rating,
		};
		onRequestSubmit?.(response);
	};
	return (
		<div className={`${css(styleSheet.container, ...styles)} satisfaction-survey ${className || ''}`}>
			<div className={css(introStyle)}>{survey.intro}</div>
			<figure className={css(styleSheet.ratingContainer)}>
				<StarRating
					animateRatingChanges={true}
					fillColor='#F3CE0D'
					onValueChanged={setRating}
					starStyles={ratingStarStyles}
					total={5}
					value={rating}
					showEmoji={false}
				/>
			</figure>
			<Button
				className={css(styleSheet.submitButton)}
				kind='primary'
				label='Submit Star Rating'
				onClick={onSubmitFeedbackClicked}
			/>
		</div>
	);
};
